module.exports = __webpack_public_path__ + "media/images/about-us/Top Right - Desert-e0ba11b62c10fc3f108eb07a412d36ef.jpeg";